var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 120,
    viewBox: "0 0 224 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.458 90.9352C111.119 90.9352 110.802 90.8453 110.508 90.6878L107.502 88.9109C107.05 88.6634 107.276 88.5734 107.412 88.5285C108.022 88.3261 108.135 88.2809 108.768 87.9212C108.836 87.8761 108.926 87.8987 108.994 87.9436L111.3 89.3157C111.39 89.3607 111.503 89.3607 111.571 89.3157L120.59 84.1196C120.68 84.0747 120.725 83.9846 120.725 83.8723V73.5026C120.725 73.3899 120.68 73.3002 120.59 73.2551L111.571 68.0815C111.48 68.0364 111.367 68.0364 111.3 68.0815L102.28 73.2551C102.19 73.3 102.145 73.4125 102.145 73.5024V83.8721C102.145 83.9622 102.19 84.0745 102.28 84.1196L104.744 85.5367C106.078 86.2115 106.914 85.4242 106.914 84.6369V74.4022C106.914 74.2673 107.027 74.1322 107.186 74.1322H108.338C108.474 74.1322 108.61 74.2447 108.61 74.4022V84.6369C108.61 86.4139 107.638 87.4487 105.942 87.4487C105.422 87.4487 105.016 87.4487 103.863 86.8862L101.489 85.5367C100.902 85.1994 100.54 84.5694 100.54 83.8946V73.525C100.54 72.8503 100.902 72.2203 101.489 71.883L110.508 66.6869C111.073 66.372 111.842 66.372 112.407 66.6869L121.426 71.883C122.014 72.2203 122.375 72.8503 122.375 73.525V83.8946C122.375 84.5694 122.014 85.1994 121.426 85.5367L112.407 90.7328C112.113 90.8679 111.774 90.9352 111.458 90.9352H111.458ZM114.238 83.8047C110.282 83.8047 109.469 82.0052 109.469 80.4757C109.469 80.3406 109.582 80.2057 109.74 80.2057H110.915C111.051 80.2057 111.164 80.2956 111.164 80.4307C111.345 81.6228 111.865 82.2076 114.261 82.2076C116.159 82.2076 116.973 81.7802 116.973 80.768C116.973 80.1831 116.747 79.7559 113.786 79.4634C111.322 79.2159 109.785 78.6762 109.785 76.7192C109.785 74.8971 111.322 73.8173 113.899 73.8173C116.792 73.8173 118.216 74.8072 118.397 76.9664C118.397 77.0341 118.375 77.1015 118.329 77.169C118.284 77.2139 118.216 77.2589 118.148 77.2589H116.973C116.86 77.2589 116.747 77.169 116.724 77.0565C116.453 75.8195 115.752 75.4144 113.899 75.4144C111.819 75.4144 111.571 76.1344 111.571 76.6741C111.571 77.3264 111.865 77.5288 114.667 77.8887C117.448 78.2488 118.759 78.7661 118.759 80.7005C118.736 82.68 117.109 83.8047 114.238 83.8047Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4738 50.3796C83.4738 49.9748 83.2477 49.5922 82.8861 49.3898L73.302 43.9014C73.1436 43.8112 72.9629 43.7663 72.7822 43.7437H72.6916C72.5109 43.7437 72.33 43.8112 72.1718 43.9014L62.5877 49.3898C62.2259 49.5922 62 49.9746 62 50.3796L62.0227 65.1355C62.0227 65.338 62.1357 65.5404 62.3164 65.6305C62.4974 65.743 62.7232 65.743 62.8817 65.6305L68.5778 62.3913C68.9395 62.1889 69.1656 61.8065 69.1656 61.4017V54.496C69.1656 54.0911 69.3914 53.7087 69.7533 53.5063L72.1718 52.1116C72.3527 51.9991 72.5561 51.954 72.7595 51.954C72.9629 51.954 73.1663 51.9991 73.3247 52.1116L75.7432 53.5063C76.105 53.7087 76.3309 54.091 76.3309 54.496V61.4017C76.3309 61.8065 76.557 62.1889 76.9186 62.3913L82.6148 65.6305C82.7957 65.743 83.0216 65.743 83.2025 65.6305C83.3834 65.5404 83.4965 65.338 83.4965 65.1355L83.4738 50.3796ZM129.541 30.0676C129.36 29.9775 129.134 29.9775 128.975 30.0676C128.795 30.1801 128.682 30.3599 128.682 30.5623V45.1835C128.682 45.3184 128.614 45.4533 128.478 45.5434C128.343 45.6107 128.207 45.6107 128.071 45.5434L125.675 44.1713C125.5 44.0718 125.301 44.0194 125.099 44.0194C124.897 44.0194 124.698 44.0718 124.523 44.1713L114.938 49.6823C114.577 49.8847 114.351 50.2672 114.351 50.672V61.6714C114.351 62.0762 114.577 62.4589 114.938 62.6613L124.523 68.1723C124.698 68.2718 124.897 68.3242 125.099 68.3242C125.301 68.3242 125.5 68.2718 125.675 68.1723L135.26 62.6613C135.621 62.4589 135.847 62.0764 135.847 61.6714V34.2514C135.847 33.824 135.621 33.4418 135.26 33.2392L129.541 30.0676H129.541ZM128.659 58.05C128.659 58.1625 128.614 58.2524 128.523 58.2974L125.246 60.1868C125.2 60.209 125.15 60.2206 125.099 60.2206C125.048 60.2206 124.998 60.209 124.952 60.1868L121.675 58.2974C121.584 58.2524 121.539 58.1399 121.539 58.05V54.271C121.539 54.1585 121.584 54.0686 121.675 54.0236L124.952 52.134C124.998 52.1118 125.048 52.1002 125.099 52.1002C125.15 52.1002 125.2 52.1118 125.246 52.134L128.523 54.0236C128.614 54.0684 128.659 54.1811 128.659 54.271V58.05ZM161.435 54.1811C161.797 53.9787 162 53.5962 162 53.1912V50.5145C162 50.1097 161.774 49.7273 161.435 49.5249L151.919 44.0364C151.743 43.9369 151.544 43.8846 151.342 43.8846C151.14 43.8846 150.941 43.9369 150.766 44.0364L141.182 49.5472C140.82 49.7496 140.594 50.1321 140.594 50.5371V61.5365C140.594 61.9414 140.82 62.3238 141.182 62.5262L150.698 67.9247C151.06 68.1271 151.489 68.1271 151.828 67.9247L157.592 64.7309C157.773 64.6408 157.886 64.4384 157.886 64.236C157.886 64.0336 157.773 63.8312 157.592 63.7411L147.963 58.23C147.782 58.1178 147.669 57.9377 147.669 57.7353V54.2938C147.669 54.0913 147.782 53.8889 147.963 53.7988L150.969 52.0892C151.057 52.0341 151.159 52.0049 151.263 52.0049C151.367 52.0049 151.469 52.0341 151.557 52.0892L154.563 53.7988C154.744 53.9113 154.857 54.0911 154.857 54.2938V56.993C154.857 57.1954 154.97 57.3978 155.151 57.4877C155.332 57.6002 155.558 57.6002 155.739 57.4877L161.435 54.1811Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.196 53.6631C151.229 53.6411 151.268 53.6294 151.308 53.6294C151.349 53.6294 151.388 53.6411 151.421 53.6631L153.252 54.7203C153.32 54.765 153.365 54.8326 153.365 54.9227V57.0371C153.365 57.127 153.32 57.1945 153.252 57.2395L151.421 58.2967C151.388 58.3187 151.349 58.3304 151.308 58.3304C151.268 58.3304 151.229 58.3187 151.196 58.2967L149.365 57.2395C149.297 57.1945 149.251 57.127 149.251 57.0371V54.9227C149.251 54.8326 149.297 54.765 149.365 54.7203L151.196 53.6631Z",
    fill: "#539E43"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5278_18254",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 43,
    width: 22,
    height: 26
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4993 44.08C99.3236 43.9805 99.125 43.9282 98.9229 43.9282C98.7208 43.9282 98.5222 43.9805 98.3466 44.08L88.8304 49.5457C88.4685 49.7481 88.2651 50.1305 88.2651 50.5354V61.49C88.2651 61.8949 88.4912 62.2773 88.8304 62.4797L98.3466 67.9458C98.5222 68.0453 98.7208 68.0976 98.9229 68.0976C99.125 68.0976 99.3236 68.0453 99.4993 67.9458L109.016 62.4797C109.377 62.2773 109.581 61.8949 109.581 61.49V50.5356C109.581 50.1307 109.355 49.7483 109.016 49.5459L99.4993 44.08Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5278_18254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4993 44.08C99.3236 43.9805 99.125 43.9282 98.9229 43.9282C98.7208 43.9282 98.5222 43.9805 98.3466 44.08L88.8304 49.5457C88.4685 49.7481 88.2651 50.1305 88.2651 50.5354V61.49C88.2651 61.8949 88.4912 62.2773 88.8304 62.4797L98.3466 67.9458C98.5222 68.0453 98.7208 68.0976 98.9229 68.0976C99.125 68.0976 99.3236 68.0453 99.4993 67.9458L109.016 62.4797C109.377 62.2773 109.581 61.8949 109.581 61.49V50.5356C109.581 50.1307 109.355 49.7483 109.016 49.5459L99.4993 44.08Z",
    fill: "url(#paint0_linear_5278_18254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.038 49.5476L99.477 44.0817C99.3831 44.0345 99.2846 43.9968 99.183 43.9692L88.4688 62.2344C88.5575 62.3423 88.6647 62.4336 88.7854 62.5044L98.3468 67.9704C98.618 68.1279 98.9345 68.1728 99.2282 68.0827L109.287 49.7728C109.219 49.6829 109.129 49.6151 109.038 49.5478V49.5476Z",
    fill: "url(#paint1_linear_5278_18254)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.061 62.4822C109.332 62.3247 109.535 62.0548 109.626 61.7624L99.1374 43.9472C98.8661 43.9023 98.5722 43.9247 98.3238 44.0821L88.8301 49.5258L99.0695 68.1057C99.2184 68.0814 99.3631 68.036 99.499 67.9708L109.061 62.4824L109.061 62.4822Z",
    fill: "url(#paint2_linear_5278_18254)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.061 62.4816L99.5218 67.9476C99.3871 68.0159 99.242 68.0615 99.0923 68.0825L99.2732 68.4199L109.852 62.3243V62.1892L109.58 61.7393C109.535 62.0542 109.332 62.3241 109.061 62.4816Z",
    fill: "url(#paint3_linear_5278_18254)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.061 62.4816L99.5218 67.9476C99.3871 68.0159 99.242 68.0615 99.0923 68.0825L99.2732 68.4199L109.852 62.3243V62.1892L109.58 61.7393C109.535 62.0542 109.332 62.3241 109.061 62.4816Z",
    fill: "url(#paint4_linear_5278_18254)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5278_18254",
    x1: 102.8,
    y1: 48.1547,
    x2: 92.4415,
    y2: 64.5104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5278_18254",
    x1: 97.4783,
    y1: 57.2978,
    x2: 123.543,
    y2: 43.0674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5278_18254",
    x1: 87.9173,
    y1: 56.0155,
    x2: 109.938,
    y2: 56.0155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5278_18254",
    x1: 87.9174,
    y1: 65.098,
    x2: 109.938,
    y2: 65.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5278_18254",
    x1: 113.146,
    y1: 47.6384,
    x2: 107.619,
    y2: 76.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.fc692c98765d93152cae914db20f61a4.svg";
export { ForwardRef as ReactComponent };